import { useState } from "react";
import { UploadButton } from "./ant/button";
import {
  UploadRequestError,
  UploadRequestOption,
} from "rc-upload/lib/interface";
import axios from "axios";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import download from "js-file-download";

interface IImportButtonProps {
  text: string;
}

const restURL = process.env.REACT_APP_API_ENDPOINT;
export const IMPORT_URL = `${restURL}/configuration/import`;

const ImportButton = ({ text }: IImportButtonProps) => {
  const { t } = useTranslation();
  const [isUploading, setIsUploading] = useState(false);

  const handleFileUpload = async ({
    file,
    onSuccess,
    onError,
  }: UploadRequestOption) => {
    setIsUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await axios.post(IMPORT_URL, formData, {
        responseType: "blob",
      });
      const fileName = response.headers["content-disposition"]
        ?.split("filename=")[1]
        .trim();
      download(response.data, fileName);
      onSuccess?.(response.data, response.request);
      message.success(t("common.upload.finished"));
    } catch (error: any) {
      const uploadError: UploadRequestError = {
        name: "UploadError",
        message:
          error.response?.data?.message || "An error occurred during upload",
        stack: error.stack || "",
        status: error.response?.status,
        method: error.config?.method,
        url: error.config?.url,
      };
      onError?.(uploadError);
      message.error(t("import.error"));
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <UploadButton
      accept=".xlsx"
      showUploadList={false}
      customRequest={handleFileUpload}
      buttonProps={{ loading: isUploading, text }}
    />
  );
};

export default ImportButton;
